export const KNOWLEDGE_CENTER_TOOLTIP = 'Click for more information in the SQUIRE Knowledge Center';

export const HELP_CENTER_HOME_URL = 'https://getsquire.my.site.com/help/s';

export const ONE_TOUCH_PAYOUT_HELP_URL = `${HELP_CENTER_HOME_URL}/article/Using-Auto-Payout`;
export const CUSTOM_REPORTS_HELP_URL = `${HELP_CENTER_HOME_URL}/article/UsingCustomReportsShops6239f10bca9d2`;
export const EXPORT_CLIENTS_HELP_URL = `${HELP_CENTER_HOME_URL}/article/ExportingClientListsShopBarber6239f73d94261`;
export const AUTO_PAYOUT_ELIGIBILITY_URL = `${HELP_CENTER_HOME_URL}/article/Auto-Payout-Eligibility`;
export const AUTO_PAYOUT_ELIGIBILITY_COMMISSION_SPLIT_URL = `${AUTO_PAYOUT_ELIGIBILITY_URL}#Split`;
export const AUTO_PAYOUT_ELIGIBILITY_CREDIT_TO_CASH_RATIO_URL = `${AUTO_PAYOUT_ELIGIBILITY_URL}#Ratio`;
export const AUTO_PAYOUT_ELIGIBILITY_BARBER_BANK_ACCOUNT_URL = `${AUTO_PAYOUT_ELIGIBILITY_URL}#Bank`;
export const AUTO_PAYOUT_ELIGIBILITY_ACTIVE_FINANCING_URL = `${AUTO_PAYOUT_ELIGIBILITY_URL}#Cap`;
